import axios from "axios";
import React, { useEffect, useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/autoplay";
import { Navigation, Pagination, Autoplay } from "swiper/modules";
const TestimonialC = () => {
    const [testimonials,setTestimonials] = useState([]);

    useEffect (() =>{
        const apiBaseUrl = process.env.REACT_APP_API_BASE_URL;
        const Url = process.env.REACT_APP_API_TESTIMONIALS;
        axios.get(`${apiBaseUrl}${Url}`)
        .then(response => setTestimonials(response.data))
        .catch(error => console.error("Fetch Error",error));
    },[]);

    return (
        <Swiper
            modules={[Navigation, Pagination, Autoplay]}
            navigation
            pagination={{ clickable: true }}
            loop={true}
            spaceBetween={10}

            autoplay={{
                delay: 2500,
                disableOnInteraction: false,
            }}
            breakpoints={{
                320: {
                    slidesPerView: 1,  // 1 slide visible on small screens (sm)
                },
                768: {
                    slidesPerView: 2,  // 2 slides visible on medium screens (md)
                },
                1024: {
                    slidesPerView: 3,  // 3 slides visible on large screens (lg)
                },
            }}
        >

            {testimonials.map((testimonial, index) => {
                return (
                    <SwiperSlide>
                        <div className="testi-carousel__item" key={testimonial.id}>
                            <div className="media">
                                <div className="testi-carousel__img">
                                    <img width={75} src={testimonial.image} alt="" />
                                </div>
                                <div className="media-body">
                                    <p align="justify">{testimonial.comment}</p>
                                    <div className="testi-carousel__intro">
                                        <h3>{testimonial.name}</h3>
                                        <p>{testimonial.designation}</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </SwiperSlide>
                );
            })}
        </Swiper>
    );
}

export default TestimonialC;